"use client";

import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { useShell } from "@/components/shell/ShellContext";
import { useToasts } from "@/components/ui/Toast";

/* Where a player adds the email a withdrawal needs: Settings → Account's Email
   Address card, opened on its add form. The template's stand-in for the
   whitelabel's VerifyEmailModal — the same send-a-link flow, on the account
   page rather than in a modal. */
export const EMAIL_SETTINGS_HREF = "/account?tab=Settings&focus=email-address";

export const EMAIL_VERIFICATION_MESSAGE = "Please verify your email address before withdrawing.";

/* The whitelabel's useEmailVerificationRedirect: close the wallet and send the
   player to the email flow, saying why. */
export const useEmailVerificationRedirect = () => {
  const { closeWallet } = useShell();
  const router = useRouter();
  const { push } = useToasts();

  return useCallback(
    (message: string = EMAIL_VERIFICATION_MESSAGE) => {
      closeWallet();
      push({ tone: "info", icon: "mail", title: message });
      router.push(EMAIL_SETTINGS_HREF);
    },
    [closeWallet, push, router],
  );
};
